import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BlogImg from "../assets/img/zenBlog.png";
import config from "../config/env";
import { formatDate } from "../utils/dateFormatter";
import MinimalLoader from "./Loader";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NotFound from "../pages/notFound/NotFound";

export default function NewsDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch Post and Comments
  useEffect(() => {
    fetch(`${config.API_URL}/api/posts/slug/${slug}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          throw Error("Post not found");
        }
        setPost(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching post:", error);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div>
        <MinimalLoader />
      </div>
    );
  }
  if (!post && !loading) {
    return <NotFound title="News not found" />;
  }

  return (
    <>
      <Navbar />

      <div className="min-h-screen bg-white pt-20">
        <main className="max-w-5xl mx-auto px-6 md:px-10 lg:px-6  md:py-10 grid grid-cols-4 gap-10">
          <article className="col-span-full md:col-span-3 flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <span className="bg-primary text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1">
                {post.category}
              </span>
              <time
                dateTime={post.published_at}
                className="text-secondary/40 text-xs"
              >
                {formatDate(post.published_at)}
              </time>
            </div>

            <h1 className="font-extrabold text-2xl leading-snug text-secondary">
              {post.title}
            </h1>

            <div className="w-full overflow-hidden h-72">
              <img
                src={post.featured_image ? `${post.featured_image}` : BlogImg}
                alt={post.title}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex flex-col gap-4">
              <div
                dangerouslySetInnerHTML={{ __html: post?.content }}
                className="space-y-6 text-secondary/80 text-sm leading-relaxed"
              />
            </div>
          </article>
        </main>
      </div>
      <Footer />
    </>
  );
}
